// import React from 'react'
import PropTypes from 'prop-types'
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import AlertTriangle from '../../../assets/icon/postingan_saya/alert-triangle.svg';
import { ButtonContained, ButtonOutlined } from '../Button';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const index = ({ open, handleClose, labelPesan, isiPesan, tipePesan = 'text', labelTombol }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => handleClose(0)}
      aria-describedby="alert-dialog-slide-description"
    >
      <div style={{ padding: '20px' }}>
        <DialogContent>
          <div style={{ display: 'flex' }}>
            <img src={AlertTriangle} style={{ margin: '0px 8px 0px -20px' }} />
            <div>
              <label style={{ fontWeight: '600', fontSize: '14pt' }}>{labelPesan}</label>
              {tipePesan === 'text' && <p style={{ fontWeight: '400', fontSize: '11pt', marginTop: '8px' }}>{isiPesan}</p>}
              {tipePesan === 'node' && <div dangerouslySetInnerHTML={{ __html: isiPesan }}></div>}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <ButtonOutlined variant="outlined" onClick={() => handleClose(0)}>Batal</ButtonOutlined>
          <ButtonContained variant="contained" onClick={() => handleClose(1)}>{labelTombol ? labelTombol : 'Hapus'}</ButtonContained>
        </DialogActions>
      </div>
    </Dialog>
  )
}

index.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.func,
  isiPesan: PropTypes.string,
  tipePesan: PropTypes.string,
  labelPesan: PropTypes.string,
  labelTombol: PropTypes.string
}

export default index
